if (!customElements.get('label-comparison')) {
  class LabelComparison extends HTMLElement {
    opener = null;

    connectedCallback() {
      this.onClick = this.handleClick.bind(this);
      this.onClose = this.handleClose.bind(this);

      this.addEventListener('click', this.onClick);
      // `close` does not bubble, so listen in the capture phase.
      this.addEventListener('close', this.onClose, true);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('close', this.onClose, true);
      document.body.classList.remove('overflow-hidden');
    }

    /**
     * Opens a dialog from its trigger, closes it from its close button or a backdrop click.
     * @param {MouseEvent} event
     * @returns {void}
     */
    handleClick(event) {
      const opener = event.target.closest('[data-dialog-open]');

      if (opener) {
        const dialog = this.querySelector(`#${opener.dataset.dialogOpen}`);
        if (!dialog) return;

        this.opener = opener;
        dialog.showModal();
        document.body.classList.add('overflow-hidden');
        return;
      }

      const closeButton = event.target.closest('[data-dialog-close]');

      if (closeButton) {
        closeButton.closest('dialog')?.close();
        return;
      }

      if (event.target instanceof HTMLDialogElement && this.isOutside(event, event.target)) event.target.close();
    }

    /**
     * The dialog element is also the target for clicks on its own padding, so compare against its box.
     * @param {MouseEvent} event
     * @param {HTMLDialogElement} dialog
     * @returns {boolean}
     */
    isOutside(event, dialog) {
      const rect = dialog.getBoundingClientRect();

      return (
        event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom
      );
    }

    handleClose() {
      document.body.classList.remove('overflow-hidden');
      this.opener?.focus();
      this.opener = null;
    }
  }

  customElements.define('label-comparison', LabelComparison);
}
